import { render, staticRenderFns } from "./dispatchingPlaceCode.vue?vue&type=template&id=367f286c&"
import script from "./dispatchingPlaceCode.vue?vue&type=script&lang=js&"
export * from "./dispatchingPlaceCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('367f286c')) {
      api.createRecord('367f286c', component.options)
    } else {
      api.reload('367f286c', component.options)
    }
    module.hot.accept("./dispatchingPlaceCode.vue?vue&type=template&id=367f286c&", function () {
      api.rerender('367f286c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/cargoDoc/dispatchingPlaceCode.vue"
export default component.exports